/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Checkbox } from '@altermaind/web/ui';
import { Column } from '../types';

type CheckboxColumnParams = {
  allPageSelected: boolean;
  allPageIds: string[];
  selectedItems: string[];
  hoveredId: string | undefined;
  onSelectionChange?: (items: string[]) => void;
  getId: (item: any) => string;
};

export const buildCheckboxColumn = ({
  allPageSelected,
  allPageIds,
  selectedItems,
  hoveredId,
  onSelectionChange,
  getId,
}: CheckboxColumnParams): Column => ({
  key: '__checkbox',
  width: '30px',
  title: (
    <Box pl='xs' display='flex' alignItems='center'>
      <Checkbox
        checked={!!allPageSelected}
        onClick={e => {
          e.stopPropagation();
          onSelectionChange?.(
            allPageSelected
              ? selectedItems.filter(id => !allPageIds.includes(id))
              : [...new Set([...selectedItems, ...allPageIds])],
          );
        }}
      />
    </Box>
  ),
  renderValue: (item: any) => {
    const isChecked = selectedItems.includes(getId(item));
    const isVisible = isChecked || hoveredId === getId(item);
    return (
      <Box
        display='flex'
        alignItems='center'
        style={{ opacity: isVisible ? 1 : 0, transition: 'opacity 0.15s' }}
        // Prevent clicks anywhere in the checkbox cell from triggering the row navigation
        onClick={e => e.stopPropagation()}
      >
        <Checkbox
          checked={isChecked}
          onClick={e => {
            e.stopPropagation();
            onSelectionChange?.(
              isChecked
                ? selectedItems.filter(x => x !== getId(item))
                : [...selectedItems, getId(item)],
            );
          }}
        />
      </Box>
    );
  },
});
